// extracted by mini-css-extract-plugin
export default {"btn":"Todo_btn__ANHZH","todo-btns-group":"Todo_todo-btns-group__jn3x0","todo__checkbox":"Todo_todo__checkbox__iGBJJ","todo-inputs-group":"Todo_todo-inputs-group__XXP9R"};